import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectHasAnyGroup, selectUsername } from '../../redux/selector/system'
import { syncNotificationDeviceThunk } from '../../redux/thunk/notificationsDevices'
import { localStorageApi } from '../../helper/localStorageApi'

const POLLING_INTERVAL_MS = 60 * 1000

const AppStatus = () => {
	const dispatch = useDispatch()
	const userName = useSelector(selectUsername)
	const isWaiter = useSelector(selectHasAnyGroup(['WAITER']))
	const isAppOpen = useSelector(store => store.notifications.isAppOpen)
	const [appNotificationData, setAppNotificationData] = useState(null)
	const deviceId = appNotificationData?.deviceId
	const token = appNotificationData?.expoPushToken

	useEffect(() => {
		const data = localStorageApi.getItem('appNotificationData')
		setAppNotificationData(data)
	}, [])

	const syncNotificationDevice = (userName, deviceId, token) =>
		dispatch(syncNotificationDeviceThunk(
			userName,
			deviceId,
			token,
		))

	useEffect(() => {
		if (isWaiter && deviceId) {
			syncNotificationDevice(userName, deviceId, token)
		}
	}, [isWaiter, deviceId, token]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		const interval = setInterval(() => {
			if (isAppOpen && isWaiter && deviceId) {
				syncNotificationDevice(userName, deviceId, token)
			}
		}, POLLING_INTERVAL_MS)

		return () => clearInterval(interval)
	}, [isAppOpen, isWaiter, deviceId, token]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		const handleVisibilityChange = () => {
			if (document.visibilityState === 'visible' && isWaiter && deviceId) {
				syncNotificationDevice(userName, deviceId, token)
			}
		}

		document.addEventListener('visibilitychange', handleVisibilityChange)

		return () => document.removeEventListener('visibilitychange', handleVisibilityChange)
	}, [isWaiter, deviceId, token]) // eslint-disable-line react-hooks/exhaustive-deps

	return null
}

AppStatus.displayName = 'AppStatus'
export default AppStatus
